import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import SkeletonTableLoad from "../../components/SkeletonTableLoad";
import { DecisionTable } from "../../models/Admin/DistanceBands";
import msalRestClient from "../../services/clients/MsalRestClient";

const DistanceBandOverview = () => {

    const [isLoading, setIsLoading] = useState<boolean>(false);

    const [selectedVersion, setSelectedVersion] = useState<number>(1);
    const [decisionTables,  setDecisionTables]  = useState<DecisionTable[]>([]);

    useEffect(() => {
        fetchDistanceBands();
    }, []);

    /**
     * Method fetches a collection of all saved DistanceBandSets.
     */
    async function fetchDistanceBands() {

        setIsLoading(true);

        /* Fetch data from backend service */
        msalRestClient.get<DecisionTable[]>("/api/tables/autocomplete")
            .then(response => {
                if (response.status === 200) {
                    /* Set fetched distanceBandSets to the current state */
                    setDecisionTables(response.data);
                }
                else if (response.status === 204) {
                    /* No distanceBandsSet could be found for the specified filter, set state to empty collection */
                    setDecisionTables([]);
                }
            })
            .catch(error => { })
            .finally(() => setIsLoading(false));

    }

    /* JSX Element for rendering in Browser */
    return (
        <main className="container">
            <div className="row">

                <div className="col-12">
                    <div className="card mb-3">
                        <div className="card-body">
                            {
                                isLoading ? <SkeletonTableLoad columnCount={5} rowCount={15} striped={false} />
                                    :
                                    <table className="table table-striped">
                                        <thead>
                                            <tr>
                                                <th colSpan={3}>
                                                    <label>Table</label>
                                                    <div className="input-group mt-2">
                                                        <select className="form-select mb-2" defaultValue={selectedVersion} onChange={e => setSelectedVersion(Number(e.target.value))}>
                                                            {
                                                                decisionTables.map((value, index) => {
                                                                    return (
                                                                        <option value={value.id}>{value.name}</option>
                                                                    )
                                                                })
                                                            }
                                                        </select>
                                                        <div className="input-group-append">
                                                            <NavLink to={"/admin/tables/" + selectedVersion} className="btn btn-primary">
                                                                <i className="bi bi-pen"></i>
                                                            </NavLink>
                                                            <NavLink to={"/admin/tables/copy/" + selectedVersion} className="btn btn-warning">
                                                                <i className="bi bi-clipboard"></i>
                                                            </NavLink>
                                                            <NavLink to={"/admin/tables/create"} className="btn btn-success">
                                                                <i className="bi bi-plus-lg"></i>
                                                            </NavLink>
                                                        </div>
                                                    </div>
                                                </th>
                                                <th colSpan={2}></th>
                                            </tr>
                                            <tr>
                                                <th>#</th>
                                                <th>Min. Value</th>
                                                <th>Max. Value</th>
                                                <th>Amount</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                decisionTables.find(x => x.id === selectedVersion)?.distanceBands.sort(x => Number(x.minValue)).map((x, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <td>{x.id}</td>
                                                            <td>{x.minValue} km</td>
                                                            <td>{x.maxValue} km</td>
                                                            <td>{x.amount} &euro;</td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                            }
                        </div>
                    </div>
                </div>

            </div>
        </main>
    )

}
export default DistanceBandOverview;